// extracted by mini-css-extract-plugin
module.exports = {"geoJSONErrorWrapper":"CoordinatesMoreInfo_geoJSONErrorWrapper__GhlWe"};